/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


let localDBStringEl = document.querySelector("#localdb");
if(localDBStringEl){
  let localDBString = decodeURIComponent(localDBStringEl.innerText);
  let localDB = JSON.parse(localDBString);
  let comboName = "";
  let productDetailsEl = document.querySelector("#productDetailsFromDB");

  // for demo theme
  // let variantSelectsEl = document.querySelector("variant-selects");

  // for palo alto theme
  let selectedVariantEl = document.querySelector("input[name=id]");


  function showVariantDetails(){
    // variantSelectsEl.querySelectorAll("input").forEach((el, idx) => {
    //   if (idx === 0) comboName = "";
    //   if (el.checked) {
    //     comboName += el.value;
    //   }
    // });


    // palo alto theme
    let selectedVariantDetails = meta.product.variants.find(el=>el.id == selectedVariantEl.value);
    comboName = selectedVariantDetails.public_title.replaceAll('"','');
    if(!localDB[comboName]){
      productDetailsEl.innerHTML = '';
      return;
    }

    productDetailsEl.innerHTML = `
    <style>
      #productDetailsTable{ box-shadow: none; border:0; } 
      #productDetailsTable td{ 
        border: 0px solid #000;
        width: 50%;
        border-bottom: 1px solid #e8e8e8;
      }
    </style>
    <div style="font-weight: bold;">Based on your selection</div>
    <table id="productDetailsTable">
      <tr>
        <td>Approx Weight</td>
        <td>${localDB[comboName].approxWeight} Gr.</td>
      </tr>
      <tr>
        <td>Effective Carat Weight</td>
        <td>${localDB[comboName].EffectiveCaratWeight} ct.</td>
      </tr>
      <tr>
        <td>Number of Stones</td>
        <td>${localDB[comboName].NoofStones}</td>
      </tr>
      <tr>
        <td>Stone Carat Weight</td>
        <td>${localDB[comboName].StoneCaratWeight}</td>
      </tr>
      <tr>
        <td>Stone Size</td>
        <td>${localDB[comboName].StonesSize.replace(/.+?X/,'')}</td>
      </tr>
    </table>
    `;
  }

  showVariantDetails();
  productDetailsEl.style.display = "block";

  // wait for any clicks
  // document.querySelector('.product__selectors').addEventListener("click", (e) => {
  //   if (e.target.nodeName === "INPUT") {
  //     setTimeout(showVariantDetails, 500);
  //   }
  // });

  // wait for any change of variation in the dom
  const observer = new MutationObserver((mutationsList, observer) => {
    for (let mutation of mutationsList) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
            showVariantDetails();
        }
    }
  });

  observer.observe(selectedVariantEl, { attributes: true, attributeFilter: ['value'] });

}












(function () {
  if (document.querySelector('#quotation_button')) {
    // Add custom code below this line
    document.querySelector('#quotation_button').addEventListener('click', function (event) {
      event.preventDefault();
      document.querySelector('#quotation_form').style.display = 'flex';
      document.body.classList.add('no-scroll');
    });

    document.querySelector('#quotation_form__close-button').addEventListener('click', function (event) {
      event.preventDefault();
      document.querySelector('#quotation_form').style.display = 'none';
      document.body.classList.remove('no-scroll');
    });
    // ^^ Keep your scripts inside this IIFE function call to
    // avoid leaking your variables into the global scope.
  }
})();


// Selecting the radio buttons and the custom amount checkbox
const radioButtons = document.querySelectorAll('.pricing-list-items input[name="contact[amountOff]"]');
const customAmountCheckbox = document.querySelector('input[name="custom_amt"]');
const customAmounttextField = document.querySelector('.custom-amt input[name="contact[amountOff]"]');
if (radioButtons && customAmountCheckbox) {
  radioButtons.forEach(radioButton => {
    radioButton.addEventListener('change', () => {
      customAmountCheckbox.checked = false
      customAmountCheckbox.parentElement.classList.remove('active');
      customAmounttextField.setAttribute('disabled', '');
      if (radioButton.checked) {
        customAmounttextField.value = '';
      }
    });
  });
}

if (customAmounttextField) {
  customAmounttextField.addEventListener("keyup", (e) => {
    var d_price = e.target.value;
    var main_P = e.target.getAttribute('data-total-price');

    var discountedPrice = parseInt(d_price * 100);
    var listPrice = parseInt(main_P);

    const percentOff = Math.round(100 - (discountedPrice / listPrice) * 100);
    if (percentOff > 5 && percentOff <= 20) {
      document.querySelector('.custom-amt .total-percentage').innerHTML = percentOff + '%';
    } else {

    }
  });
}
customAmountCheckbox?.addEventListener('change', () => {
  if (customAmountCheckbox.checked) {
    customAmountCheckbox.parentElement.classList.add('active')
    customAmounttextField.removeAttribute('disabled');
    radioButtons.forEach(radioButton => {
      radioButton.checked = false;
    });
  } else {
    customAmountCheckbox.parentElement.classList.remove('active');
    customAmounttextField.setAttribute('disabled', '');
  }
});

//Custom Message 
const customMsgCheckbox = document.querySelector('input[name="custom_msg"]');
const customMsgtextField = document.querySelector('.message textarea[name="contact[body]"]');
if (customMsgtextField && customMsgCheckbox) {
  customMsgCheckbox.addEventListener('change', function () {
    if (this.checked) {
      customMsgtextField.removeAttribute('disabled');
    } else {
      customMsgtextField.setAttribute('disabled', '');
    }
  });
}

// All reviews Page js 

 // Read more and Rea less on bases of lines 
 function initReadMoreForVisibleReviews() {
  const contentElements = document.querySelectorAll('.review-text__content');
  contentElements.forEach(content => {
      const parentItem = content.closest('.all-reviews-item');
      if (window.getComputedStyle(parentItem).display === 'block') {
          const container = content.closest('.review-txt');
          const originalText = content.innerHTML; // Use innerHTML for text with HTML tags
          const words = originalText.split(' ');

          const tempElement = document.createElement('div');
          tempElement.style.visibility = 'hidden';
          tempElement.style.position = 'absolute';
          tempElement.style.width = content.getBoundingClientRect().width + 'px';
          tempElement.style.lineHeight = window.getComputedStyle(content).lineHeight;
          document.body.appendChild(tempElement);

          tempElement.textContent = originalText;
          const lineHeight = parseFloat(window.getComputedStyle(content).lineHeight);
          const targetHeight = lineHeight * 4;

          if (tempElement.offsetHeight <= targetHeight) {
              document.body.removeChild(tempElement);
              content.innerHTML = originalText;
              return;
          }

          let start = 0;
          let end = words.length;
          let finalWordCount = 0;

          while (start <= end) {
              const mid = Math.floor((start + end) / 2);
              tempElement.textContent = words.slice(0, mid).join(' ');

              if (tempElement.offsetHeight <= targetHeight) {
                  finalWordCount = mid;
                  start = mid + 1;
              } else {
                  end = mid - 1;
              }
          }

          document.body.removeChild(tempElement);

          let isExpanded = false;

          function updateText() {
              if (!isExpanded) {
                  const truncatedText = words.slice(0, finalWordCount).join(' ');
                  content.innerHTML = truncatedText + ' <span class="read-more-link">Read More</span>';
              } else {
                  content.innerHTML = originalText + ' <span class="read-more-link">Read Less</span>';
              }

              const link = content.querySelector('.read-more-link');
              link.onclick = function () {
                  isExpanded = !isExpanded;
                  updateText();
              };
          }

          updateText();
      }
  });
}


// // Custom Pagination
// document.addEventListener('DOMContentLoaded', function () {
//   const reviewsPerPage = 10;
//   const reviews = document.querySelectorAll('.all-reviews-item');
//   const totalReviews = reviews.length;
//   const totalPages = Math.ceil(totalReviews / reviewsPerPage);

//   // Retrieve currentPage from the URL parameter, default to 1 if not set
//   const urlParams = new URLSearchParams(window.location.search);
//   let currentPage = parseInt(urlParams.get('page')) || 1;

//   function showPage(page) {
//       currentPage = page; 
//       window.scrollTo({ top: 0, behavior: 'smooth' });
//       initReadMoreForVisibleReviews();
//       // Update the URL without reloading the page
//       const newUrl = new URL(window.location.href);
//       newUrl.searchParams.set('page', currentPage);
//       window.history.pushState(null, '', newUrl);

//       const startIndex = (page - 1) * reviewsPerPage;
//       const endIndex = startIndex + reviewsPerPage;

//       reviews.forEach((review) => {
//           review.style.display = 'none';
//       });

//       for (let i = startIndex; i < endIndex; i++) {
//           if (reviews[i]) {
//               reviews[i].style.display = 'block';
//           }
//       }

//       const pageLinks = [];
//       const maxVisiblePages = 5;

//       pageLinks.push(`<button class="page-link ${page === 1 ? 'active' : ''}" data-page="1">1</button>`);
//       if (page > maxVisiblePages) {
//           pageLinks.push('<span class="ellipsis">...</span>');
//       }

//       const startRange = Math.max(2, page - Math.floor(maxVisiblePages / 2));
//       const endRange = Math.min(totalPages - 1, page + Math.floor(maxVisiblePages / 2));

//       for (let i = startRange; i <= endRange; i++) {
//           pageLinks.push(`<button class="page-link ${i === page ? 'active' : ''}" data-page="${i}">${i}</button>`);
//       }

//       if (page < totalPages - maxVisiblePages) {
//           pageLinks.push('<span class="ellipsis">...</span>');
//       }

//       if (totalPages > 1) {
//           pageLinks.push(`<button class="page-link ${page === totalPages ? 'active' : ''}" data-page="${totalPages}">${totalPages}</button>`);
//       }

//       let pageInfo = document.getElementById('page-info')
//       if(pageInfo){
//         pageInfo.innerHTML = pageLinks.join(' ');
//       }

//       const pageButtons = document.querySelectorAll('.page-link');
//       pageButtons.forEach((button) => {
//           button.addEventListener('click', function () {
//               showPage(parseInt(button.getAttribute('data-page'), 10));
//           });
//       });

//       let prevBtn = document.getElementById('prev-btn')
//       if(prevBtn){
//         prevBtn.disabled = page === 1;
//       }
      
//       let nextBtn = document.getElementById('next-btn')
//       if(nextBtn){
//         nextBtn.disabled = page === totalPages;
//       }
//   }

//   function changePage(direction) {
//       const newPage = currentPage + direction;
//       if (newPage >= 1 && newPage <= totalPages) {
//           showPage(newPage);
//       }
//   }
//   let prevBtn = document.getElementById('prev-btn')
//   if(prevBtn){
//     prevBtn.addEventListener('click', function () {
//         changePage(-1);
//     });
//   }

//   let nextBtn = document.getElementById('next-btn')
//   if(nextBtn){
//     nextBtn.addEventListener('click', function () {
//         changePage(1);
//     });
//   }

//   // Show the initial page
//   showPage(currentPage);
// });


document.addEventListener("DOMContentLoaded", function () {
  const form = document.querySelector("#price_request_form");
  const openBtn = document.querySelector("#price-request");
  const closeBtn = document.querySelector("#price_request_form__close-button");

  if (!form || !openBtn || !closeBtn) return;

  // OPEN form
  openBtn.addEventListener("click", function (e) {
    e.preventDefault();
    // form.setAttribute("open", "");
    form.style.display = "flex";   
  });

  // CLOSE form
  closeBtn.addEventListener("click", function (e) {
    e.preventDefault();
    form.style.display = "none";
  });
});

